import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass} from '@angular/common';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'mc-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, MatIconModule],
})
export class NavItemComponent {
  @Input() label: string;
  @Input() link?: string;
  @Input() icon?: string;
  @Input() isActive?: boolean = false;
  @Input() iconActive?: string;
  @Input() labelIcon?: string;
  @Input() labelIconActive?: string;

  @Output() navigate = new EventEmitter();

  constructor() {}

  public onNavigate() {
    this.navigate.emit();
  }
}
